import { authenticatedFetch } from '../../../api/request';

export default function getExerciseStats(userId, exerciseId, date) {
    const url = `/v5/exercises/${exerciseId}/stats?userId=${userId}&date=${date}`;
    return authenticatedFetch(url);
}



// WEBPACK FOOTER //
// ./src/v5/LastPerformance/api/getExerciseStats.js